export const DEFAULT_MACHINE_TITLE = {
  es: 'CERTIFICADO DE CALIBRACIÓN',
  en: 'CALIBRATION CERTIFICATE'
};
